import { useState, useEffect } from "react";

// Components
import Sidebar from "../../../components/Sidebar";
import Main from "./Main";
import Form from "./Form";

// Utils
import { getAlert, getDataWithComp } from "../../../../utils/SamuiUtils";

const TbSetAP = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp("Tb_Set_AP", "ORDER BY AP_Id DESC");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      } else {
        setDataMasterList([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData(item);
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลผู้ขาย"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลผู้ขาย"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  masterList={dataMasterList}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetAP;
